"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropertyGroups;
(function (PropertyGroups) {
    PropertyGroups["SUBSCRIPTION_OPTIONS"] = "f60000d3b03b4eaaad395b2155a074a1";
})(PropertyGroups || (PropertyGroups = {}));
exports.default = PropertyGroups;
